export default __webpack_public_path__ + "static/media/something-error.46d07fac.svg";